
/**
 * 구독 상태
 */
export type SubscriptionInfoResponseSubscriptionStatus = typeof SubscriptionInfoResponseSubscriptionStatus[keyof typeof SubscriptionInfoResponseSubscriptionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionInfoResponseSubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
